const getRandomId = (prefix = 'random-id-') => {
  const randomNumber = Math.floor(Math.random() * 10000000);
  return `${prefix}-${randomNumber}`;
};

export default getRandomId;
